import { Space } from "antd";
import styled from "styled-components";

export const Container = styled(Space)`
	width: 100%;
	max-width: 480px;
	height: 70px;
	padding: 0;
	align-items: center;
	text-align: center;
	position: fixed;
	bottom: 0;
	background: ${props => props.theme.navbarColor};
	box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;

	.ant-space-item {
		flex: 0.25;
	}

	@media screen and (max-width: 395px) {
		gap: 0 !important;
	}

	#spinwheel {
		margin-bottom: -5px;
	}
`;

export const ItemWrapper = styled.div`
	text-align: center;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 5px;
`;

export const Label = styled.div`
	font-size: 12px;
	font-style: normal;
	letter-spacing: normal;
	line-height: 1.5;
	font-weight: 600;
	background: ${(props) => (props.status === "active" ? props.theme.primaryColor : "#C2C2C2")};
	-webkit-background-clip: text;
            background-clip: text;
    -webkit-text-fill-color: transparent;

	@media screen and (max-width: 330px) {
		font-size: 9px;
	}

	@media screen and (max-width: 298px) {
		font-size: 9px;
	}

	@media screen and (max-width: 272px) {
		font-size: 8px;
	}
`;
